<template>
  <div class='CartBtn'
  :style="{
    backgroundColor: Prefes.cart.corBackground,
    borderColor: Prefes.cart.corFont
  }"
  >
    <component
    :is="Prefes.cart.icon"
    :color="Prefes.cart.corFont"
    :tam="'45px'"
    />
    <div v-if="itens > 0" class="itens">{{ itens }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { icons } from '@/components/icons'
export default {
  name: 'CartBtn',
  components: { ...icons },
  computed: {
    ...mapGetters(['Prefes', 'CheckoutItens01']),
    itens () {
      return this.CheckoutItens01.length
    }
  }
}
</script>

<style scoped>
.CartBtn {
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 3px solid #CCCCCC;
  position: absolute;
  bottom: 3%;
  right: 4%;
  z-index: 998;
  cursor: pointer;
}

.itens {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  margin-top: -60px;
  margin-left: -50px;
  font-size: 14px;
  position: absolute;
  background-color: orange;
  border-radius: 50%;
}

@media screen and (max-width: 500px) {
  .CartBtn {
    bottom: 18%;
  }
}
</style>
